import Echo from 'laravel-echo';
import Pusher, { ChannelAuthorizationCallback } from 'pusher-js';
import { baseURL } from '../config/apiConfig';

declare global {
  interface Window {
    Pusher: typeof Pusher;
  }
}

window.Pusher = Pusher;

const PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY;
const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER ?? 'mt1';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let echo: Echo<any> | null = null;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getEcho(): Echo<any> | null {
  if (!PUSHER_KEY) return null;
  if (echo) return echo;

  echo = new Echo({
    broadcaster: 'pusher',
    key: PUSHER_KEY,
    cluster: PUSHER_CLUSTER,
    forceTLS: true,
    authorizer: (channel: { name: string }) => ({
      authorize(socketId: string, callback: ChannelAuthorizationCallback) {
        const token = localStorage.getItem('auth_token');
        fetch(`${baseURL}/broadcasting/auth`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ socket_id: socketId, channel_name: channel.name }),
        })
          .then(r => r.json())
          .then(data => callback(null, data))
          .catch(err => callback(err as Error, null));
      },
    }),
  });

  return echo;
}

export type ProgressEvent = {
  task_id: string;
  status: string;
  progress: number;
  message: string;
  leads_found: number | null;
  task_type: 'single' | 'bulk';
  company: string;
};

export type ExportReadyEvent = {
  task_id: string;
  company: string;
  row_count: number;
};

export function subscribeToUserChannel(
  userId: string,
  onProgress: (e: ProgressEvent) => void,
  onExportReady?: (e: ExportReadyEvent) => void
): () => void {
  const e = getEcho();
  if (!e) return () => {};

  const channel = e.private(`user.${userId}`)
    .listen('.search.progress', onProgress);

  if (onExportReady) {
    channel.listen('.export.ready', onExportReady);
  }

  return () => {
    try { e.leave(`user.${userId}`); } catch {}
    echo = null;
  };
}
